import StudentDashboard from '@/components/U1075u1083u1072u1074u1085u1072u1103.vue'
import CoursePlayer from '@/views/student/CoursePlayer.vue'
import CoursePreview from '@/views/student/CoursePreview.vue'
import DocumentViewer from '@/views/student/DocumentViewer.vue'
import CoursePage from '@/components/U1089u1090u1088u1072u1085u1080u10944.vue'
import Screen5 from '@/components/Screen5.vue'
import Screen8 from '@/components/Screen8.vue'
import {
	screen5Data,
	screen8Data,
	u1075u1083u1072u1074u1085u1072u1103Data,
	u1089u1090u1088u1072u1085u1080u10944Data,
} from '@/data.js'
import {
	AUTHENTICATED_ROLES,
	STUDENT_ONLY_ROLES,
} from '../routeRoles'

export const studentRoutes = [
	{
		path: '/student/dashboard',
		name: 'StudentDashboard',
		component: StudentDashboard,
		props: u1075u1083u1072u1074u1085u1072u1103Data,
		meta: { requiresAuth: true, roles: AUTHENTICATED_ROLES },
	},
	{
		path: '/student-dashboard',
		redirect: '/student/dashboard',
	},
	{
		path: '/student',
		redirect: '/student-dashboard',
	},
	{
		path: '/student/courses/:id/player',
		name: 'CoursePlayer',
		component: CoursePlayer,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Прохождение курса',
		},
	},
	{
		path: '/student/document-viewer',
		name: 'StudentDocumentViewer',
		redirect: to => ({
			name: 'DocumentViewer',
			query: to.query,
			hash: to.hash,
		}),
	},
	{
		path: '/document-viewer',
		name: 'DocumentViewer',
		component: DocumentViewer,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Просмотр документа',
		},
	},
	{
		path: '/course-preview/:id',
		name: 'CoursePreview',
		component: CoursePreview,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Просмотр курса',
		},
	},
	{
		path: '/student/courses/:id',
		name: 'StudentCoursePage',
		component: () => import('@/views/student/StudentCoursePage.vue'),
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Страница курса',
		},
	},
	{
		path: '/student/search',
		redirect: to => ({
			path: '/search-courses',
			query: to.query,
		}),
	},
	{
		path: '/search-courses',
		name: 'CourseCatalogPage',
		component: () => import('@/views/student/CourseCatalogPage.vue'),
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Каталог курсов',
		},
	},
	{
		path: '/homework-page',
		name: 'HomeworkPage',
		component: Screen5,
		props: screen5Data,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Домашние задания',
		},
	},
	{
		path: '/video-lessons',
		name: 'VideoLessons',
		component: Screen8,
		props: screen8Data,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Страница модуля',
		},
	},
	{
		path: '/course-page',
		name: 'CoursePage',
		component: CoursePage,
		props: u1089u1090u1088u1072u1085u1080u10944Data,
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Страница курса',
		},
	},
	{
		path: '/conference/:id',
		name: 'ConferenceRoom',
		component: () => import('@/views/conference/ConferenceRoom.vue'),
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			title: 'Видеоконференция',
		},
	},
	{
		path: '/student-dashboard/profile',
		name: 'StudentProfile',
		component: () => import('@/views/student/StudentProfile.vue'),
		meta: {
			requiresAuth: true,
			roles: STUDENT_ONLY_ROLES,
			title: 'Мой профиль',
		},
	},
	{
		path: '/student-dashboard/settings',
		name: 'StudentSettings',
		component: () => import('@/views/student/StudentSettings.vue'),
		meta: {
			requiresAuth: true,
			roles: STUDENT_ONLY_ROLES,
			title: 'Настройки',
		},
	},
	{
		path: '/help',
		name: 'HelpPage',
		component: () => import('@/views/student/HelpPage.vue'),
		meta: {
			title: 'Помощь',
		},
	},
]
